import { connect } from 'react-redux';
import { withApollo, compose } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import MemberSearch from '../../components/Search';
import { setWarningMessage, setErrorMessage } from '../../actions/messages';
import { setEnrollPersonRequest, setMemberRequest } from '../../actions';

export default compose(
  withApollo,
)(withRouter(connect(null, { setWarningMessage, setErrorMessage, setEnrollPersonRequest, setMemberRequest })(MemberSearch)));



// WEBPACK FOOTER //
// ./src/app/containers/Search/index.js